export default __webpack_public_path__ + "static/media/05.68e47cd9.jpg";